import "../books.css";

const one = (
  <div>
    <h2 id="chapter-1">Chapter 1</h2>
    <p>
      I have endured my fair share of broken bones, cuts, and pains, but all
      pale in comparison to the physical and mental agony of when I first woke.
      There is no good explanation for the experience, but imagine being burned
      alive from the inside, your muscles no more than a raging inferno while,
      every heartbeat, a great hammer pounds your skull.{" "}
    </p>
    <p>
      Even this sensation was secondary to a vast emptiness in my mind, a gaping
      void which should have been filled with memory and emotion but instead
      held sense of loss and an apathy so powerful that I hardly cared about the
      pain of my body. I managed to flicker open my eyelids once, seeing a world
      of white, before I passed out.
    </p>
    <p>
      When I woke again the pain and emptiness had lessened, the tide ebbing but
      the ocean remaining. I laid uncomfortably on my stomach in the grass of a
      small clearing with my head lolled to the side. A soft knocking on my head
      had, perhaps, awoken me. It was distinct from the brutal pounding in my
      skull, merely a soft rapping on my forehead. I opened my eyes to see a
      girl filling my field of vision, one who was half a foot tall and made of
      ivory wood. I blinked.{" "}
    </p>
    <p>
      She was still there, an expectant look set on her face. Unsure of her
      place in reality, I ignored her, closing my eyes and waiting for the
      painless release of unconsciousness. Moments later her existence was
      confirmed by a sharp pinch on my cheek. I opened an eye and glared back at
      her. She stood inches from my eye, hands set on her hips, returning my one
      eyed glare with a stubborn stare. The expression was eerily familiar to
      me. No, the girl herself was familiar, and then I realized.
    </p>
    <p>
      My memory was gone. I knew that the trees across the clearing were oaks,
      that girls weren’t normally made of wood, that the glaring light in the
      sky was the sun, but I didn’t know how I knew any of that. I had no idea
      who I was, what my name was, no recollection of friends or family. My eyes
      were wide open now, some panic managing to pierce through the vacancy in
      my head. I tried to speak, unaware of what I even intended to say, but all
      my parched throat could manage was a raspy croak. I didn’t know how long I
      had laid here, but it had surely been days since I had last had water[The
      carving was perfect, so perfect that the marvel of craftsmanship was
      transparent and the innocent beauty of the young girl, no more than a
      child, shone brightly through..].
    </p>
    <p>
      Hunger is often described in detail: a craving spreading out from your
      stomach, filling every fiber of your body, and corrupting your will.
      Thirst is worse though, much worse, a need that overwhelms any desire for
      food, a dreamy lust that will kill in a mere few days while hunger will
      take its time.{" "}
    </p>
    <p>
      The girl’s obstinate face filled with sincere worry at my state,
      delicately patting my cheek with her minuscule hand and furrowing her brow
      in determination before speaking.{" "}
    </p>
    <p>
      “I’ll be back.” No sound came out as her lips moved, rather the words
      echoed in my mind. She skipped away with surprising speed, gracefully
      slipping through the leaves as she left the clearing.
    </p>
    <p>
      I tried to look around the clearing moving nothing more than my eyes, the
      only part of my body that didn’t hurt. At first glance there was nothing
      unusual, a simple clearing in a forest of oak and pine trees. Still,
      something felt off. Wind rustled leaves, birds chirped, small animals
      flitted through the trees, but the sounds were uncanny. The wind hitting
      the leaves formed an almost whisper of foreboding in the air, the birdsong
      was held a note away from the screaming, and the innocent creatures
      darting around the forest seemed to be only a moment away from fleeing in
      terror. I waited uneasily for the girl’s return, still unsure if she was
      real or an hallucination brought about by the ever present mixture of
      pain, emptiness, and thirst.
    </p>
    <hr />
    <p>
      The girl found me again some time later as I hovered on the edge of
      consciousness, my lucidity fading to the pain and dehydration. A tiny kick
      to my cheekbone roused me from my near slumber. She held a leaf nearly her
      own size, using it to cup water. She folded the leaf and poured the water
      into my mouth, operating the leaf as easily as a kettle. I accepted the
      water in a dreamlike state, the precious liquid drizzling down my throat
      and into my chest as I closed my eyes to enjoy the truly euphoric
      sensation. The moment quickly passed but the moisture eased the dryness
      that plagued my mouth and throat.
    </p>
    <p>
      “Th-ank y-ou” I gasped out, looking at my miniature savior, She was a
      beautiful girl in her childhood, formed by wood so fine grained that the
      fibers formed her complexion. Her summer dress and delicate curls of hair
      rippled in the wind and her skin and body moved with a natural ease at
      odds with the conventional stiffness of wood. There was color there too,
      once you looked at the white of the wood long enough[hidden invisibly in
      the white of the wood]. The hair conveyed a light auburn hue, skin a warm
      beige, and irises sapphire circles that matched the accents on her white
      cotton dress.
    </p>
    <p>
      “More,” she said, turning her determined gaze from me to where she had
      gotten water and running off. She made several more trips as I slipped in
      and out of consciousness, often waking to the girl’s return. The hydration
      returned some semblance of normalcy to my body, but also began to awaken a
      deep rooted hunger. The sun that had been bright in the sky when the girl
      had begun her trips was now fading over the horizon.{" "}
    </p>
    <p>
      “It’s enough, thank you.” The words came out raspy and burned my throat,
      but at least I was now capable of speech. She nodded in response, kissing
      my forehead and curling up in front of me. “Goodnight brother.”
    </p>
    <p>
      I woke groggily in the morning to the rapping on my forehead that was
      quickly becoming a familiar wakeup call. The girl stood there with the
      same worried expression from the day before, only more severe.{" "}
    </p>
    <p>
      “Wake me later.” I unintelligibly mumbled out, eager to escape the pain
      and aches of consciousness and lulled by the strange new warmth in my
      chest and head.{" "}
    </p>
    <p>
      “No,” she shouted into my mind, moving forward and pinching my cheek. “If
      you fall asleep now you won’t wake up.” [; you got a fever overnight]{" "}
    </p>
    <p>
      It was a shocking realization, all the more so because there was nothing I
      could do. I doubted I had the strength to pull myself to my knees, much
      less survive a fever and more days of starvation and near dehydration.
    </p>
    <p> “We have to move, we need to find help.” </p>
    <p>
      “I… I can’t.” Streaks of sweat were starting to run down my forehead. Had
      I been alone I certainly would have succumbed to the sweet release of
      sleep.
    </p>
    <p>
      “Yes you can big baby, come on, I’ll help.” I smiled, resolving to attempt
      it, truly more to not let down the earnest girl trying to help me than for
      myself.
    </p>
    <p>“I’ll try.” </p>
    <p>
      “You’ll do better than try.” Her voice had a forced calm to it but the
      undertones of panic in it told the truth.{" "}
    </p>
    <p>
      I knew I would never get to my feet and even if I did it would be a
      miracle if I could hold my balance for more than a few seconds. If I
      wanted to move I would have to crawl, and if I wanted to crawl I would
      need to ride to my knees. I slowly dragged my arms up in preparation,
      feeling the deep burn muscle even from the small movement.{" "}
    </p>
    <p>
      “On the count of 3.” She had moved to my shoulder and was preparing to
      push up, for all the good that would do. I readied myself, putting my
      palms to the ground and angling my legs so I could push back on them.
    </p>
    <p>
      {" "}
      “1.. 2.. 3!” The fire that exploded in my arms and chest nearly
      overwhelmed my consciousness. It blacked my vision and suffocated me in a
      wave of vertigo until a force of will I did not know dwelled inside me
      rose and cleared my head with the clarity of focus.
    </p>
    <p>
      “Good now we just need to move!” The girl’s cheerful echo rang at odds
      with my gasping breath and shaking limbs. I began to laugh, a bone deep
      ridiculous laughter that shook my whole body and left me feeling stronger
      when it finally faded. I reached my arm out towards the girl and began to
      crawl.
    </p>
    <p>
      Monotony and a growing delirium filled the rest of the tortuous day. I
      pushed blindly forward, stumbling on my hands and knees as I followed the
      girl through the forest, moving at barely a snail’s pace. The focus that
      had filled my mind and sent me moving waned but what remained of it
      anchored on the wooden girl ahead of me.
    </p>
    <p>
      She led the way, offering continuous encouragement and choosing routes
      that I could manage. I did not stop; I knew that if I did I might never
      move again. By the time the sun was halfway through the sky my left arm
      was shaking uncontrollably and I was forced to move even slower. The sun
      descended two handspans further and the hallucinations began.{" "}
    </p>
    <p>
      Faceless people appeared in the shadows behind me, their features rendered
      indistinguishable by some trick of the light. A man and a woman stood at
      the forefront and a young girl darted playfully between their legs. There
      was no definition to their faces but I knew they were smiling and, despite
      their eerie appearance, the people were comforting, giving off a strange
      sense of belonging and attachment.
    </p>
    <p>
      {" "}
      But they were not alone. A predator prowled a distance behind them, dead
      silent in its stride and its black coat rendering it nearly invisible in
      the shade yet I somehow felt it.
    </p>
    <p>
      The dark beast in the background radiated terror. I hadn&#39;t been scared
      of dying in the forest to starvation, dehydration, and my bodily weakness.
      I hadn’t even cared, not until the girl motivated me and I uncovered some
      hidden will to survive. The panther in the shadows overwhelmed this calm
      resignation, pushing me into a primal terror and sparking panic. And it
      was moving closer.
    </p>
    <p>
      “Run” I yelled at the faceless people, or I tried to yell but it came out
      as a hoarse croak that the people gave no sign of hearing. I tried to yell
      again but managed not better. In the same way I could tell where the beast
      was I also knew that it was coming, and it wanted me. I had paused there,
      looking back at the people and trying to shout, but now I started forward
      again, ineffectually throwing myself forward in an attempt to flee the
      beast.{" "}
    </p>
    <p>
      The girl was still ahead of me, a beacon of light in my dimming vision but
      she was fading in the distance. Suddenly I felt a burn like hell fire in
      my right thigh and a rush of strength came with it, revitalizing and
      powering my leg. I surged up with the newfound strength in my right leg
      and I saw it as I rose. The tattered and torn pants of my trousers
      revealed a claw scar of undiluted black across the muscles of my thigh.
      Tendrils of darkness reached out from the three long marks, pulsating and
      growing with every beat of my heart.{" "}
    </p>
    <p>
      It frightened me, whatever was happening to my leg, but I could feel the
      beast approaching, gathering speed with ease and I started forward without
      hesitation, hardly using my left leg as I staggered along. I heard the
      voiceless screams of the faceless people behind me as the dark panther
      trampled them underfoot. My strong leg carried me along at a walking pace,
      but the beast was eating up the ground between us with vast bounds of its
      powerful haunches.
    </p>
    <p>
      I pulled in on the dark strength in the scar of my leg, heedless of the
      consequences and clueless as to what they might be. My thigh had burned
      when I had first felt it, but now the strength spread like ice water in my
      veins. It rushed through my blood in a moment, washing away the pain and
      weariness in an ecstatic sensation and flooding my senses with new
      awareness. My skin tingled with heightened sensitivity, my ears picked up
      every sound in the forest, my nose encountered new subtle and deep
      olfactory differences, and a black haze filled my eyes.
    </p>
    <p>
      The black haze brought the world around me alive with sudden clarity.
      Previously imperceptible differences in color became clear and shapes
      became more defined. Details too small to see beforehand were now obvious:
      every vein on a leaf ten paces away, an ant carrying a gooey milk-white
      substance in its mandible, an almost invisible thread of abandoned spider
      web hanging from the tree ahead.{" "}
    </p>
    <p>
      I was full out running now, flying through the woods with the wind in my
      hair, moving faster than I could have dreamed of only moments ago. But
      still the dark beast outpaced me. The foreign power in my veins
      rejuvenated and empowered, but it could only carry me so fast with my worn
      and weak muscles.
    </p>
    <p>
      The panic had been driven out by the refreshing calm of the strength from
      my leg, but it returned as the panther neared. I looked back and fell in
      helpless fright as it leaped at me, splashing into the water of a small
      stream and putting up my arms in a hopeless gesture of defense against the
      beast.
    </p>
    <p>
      The creature was massive, perhaps ten of me in weight. A sleek black coat
      covered heaps of muscle, it’s tail was long and thick and ended in a four
      fingered hand, it’s sharp claws were unsheathed, and it’s jaws were open,
      revealing immense canines and an array of smaller teeth. But it was the
      eyes that drew my full attention in the moments that I fell into the water
      and it fell on top of me, moments that played out as if time itself had
      slowed.
    </p>
    <p>
      They were pure black, not the natural black of it’s coat or the night sky,
      but a completely undiluted black, the same color as the dark scars on my
      leg. Our eyes locked as it’s claws fell upon me and it’s jaw closed around
      my head.
    </p>
  </div>
);

export default one;
